window.modalWindows = (function() {
   var m_jModalWindow = null;

   function trackListing(key, type) {
      if (key.indexOf("CBR") < 0 && key.indexOf("ERA") < 0
            && key.indexOf("LCE") < 0) {
         key = key.replace("C21", "");
         portalAjax.report({
            url : "/reporting/listing",
            data : "id=" + key + "&type=" + type
         });
      }
   }

   function trackAgent(key, type) {
      portalAjax.report({
         url : "/reporting/agent",
         data : "id=" + key + "&type=" + type
      });
   }

   function trackOffice(key, type) {
      portalAjax.report({
         url : "/reporting/office",
         data : "id=" + key + "&type=" + type
      });
   }

   function closeWindow() {
      $('#ModalWindow').empty();
   }
   function openMortgageCalc(propertyKey) {
      portalAjax.doViewEngineAjax('mortgageCalc', '/mortgageCalc.c21', $
            .param({
               id : propertyKey
            }));

      setTimeout(function() {
         $('#modalCloseButton').focus();
         mortgageModalTabNavigation();
      }, 2000);
   }

   function mortgageModalTabNavigation () {
      $('#mortCalculate').keydown(function(e) {
         if(e.key.toLowerCase() === "tab") {
            $('#modalClose').focus();
         }
      })
   }

   function openContact(agentKey, officeKey, source, sourcePage) {
      var params = {
         source : source,
         sourcePage: sourcePage
      };
      if (agentKey) {
         params.agentKey = agentKey;
      }
      if (officeKey) {
         params.officeKey = officeKey;
      }
      portalAjax.doViewEngineAjax('contactPopup', '/contactAgent.c21', $
            .param(params));

      setTimeout(function() {
         $('#modalCloseButton').focus();
         contactModalTabNavigation();
      }, 2000)
   }

   function openHybridContact(sContactUrl) {
      openPopupWindow(sContactUrl, 600, 500);
   }

   function openPropertyContact(propertyKey, source, sourceType, sourcePage) {
      var params = {
         sourceType : sourceType,
         source : source,
         sourcePage: sourcePage,
         propertyKey : propertyKey
      };
      portalAjax.doViewEngineAjax('contactPropertyPopup', '/contactProperty.c21',
            $.param(params));

      setTimeout(function() {
         $('#modalCloseButton').focus();
         contactModalTabNavigation();
      }, 2000);
   }

   function contactModalTabNavigation() {
      $('#contactSubmit').on('keydown', function(e) {
         if(e.key.toLowerCase() === "tab") {
            $('#modalClose').focus();
         }
      })
   }

   function openIDXPropertyContact(propertyKey, source, sourceType, sourcePage, feedID, officeKey) {
      var params = {
         sourceType : sourceType,
         source : source,
         sourcePage: sourcePage,
         obID : propertyKey,
         feed: feedID,
         officeKey: officeKey
      };
      portalAjax.doViewEngineAjax('contactPropertyPopup', '/contactIDXProperty.c21',
            $.param(params));
   }

   function openPopupWindow(url, width, height) {
      return window
            .open(
                  url,
                  '_blank',
                  'height='
                        + height
                        + ',width='
                        + width
                        + ',resizable=yes,status=no,toolbar=no,menubar=no,location=no,scrollbars=no');
   }
   function openVirtualTours(aTours) {
      if (aTours.length == 1) {
         var medialURL = aTours[0].mediaUrl.replace(/&amp;/g, '&');  // decode the media URL
         modalWindows.openPopupWindow(medialURL, 525, 525);
      } else {
         $.ajax({
            url: "/property/modalList.htm",
            success: function(data) {
               m_jModalWindow.html(data);
               $("#modalTitleBar").html(window.internationalization.getString("Choose a Virtual Tour"));
               var jList = $("#modalList");
               for ( var i = 0; i < aTours.length; i++) {
                  var jItem = $('<li>');
                  var jLink = $('<a href="javascript:void(0);"/>');
                  var oTour = aTours[i];
                  var medialURL = oTour.mediaUrl.replace(/&amp;/g, '&');  // decode the media URL
                  jLink.text(oTour.mediaCaption ? oTour.mediaCaption : medialURL);
                  (function(url) {
                     jLink.on("click", function() {
                        modalWindows.openPopupWindow(url, 525, 525);
                     });
                  })(medialURL);
                  jItem.append(jLink);
                  jList.append(jItem);
               }
               resizeModal();
            }
         });
      }
   }
   function openFloorplans(aFloorplan) {
      if (aFloorplan.length == 1) {
         modalWindows.openPopupWindow(aFloorplan[0].url, 525, 525);
      } else {
         $.ajax({
            url: "/property/modalList.htm",
            success: function(data) {
               m_jModalWindow.html(data);
               $("#modalTitleBar").html("Choose a Floorplan");
               var jList = $("#modalList");
               for ( var i = 0; i < aFloorplan.length; i++) {
                  var jItem = $('<li>');
                  var jLink = $('<a href="javascript:void(0);"/>');
                  var oFloorplan = aFloorplan[i];
                  jLink.text(oFloorplan.caption ? oFloorplan.caption : oFloorplan.url);
                  (function(url) {
                     jLink.on("click", function() {
                        modalWindows.openPopupWindow(url, 525, 525);
                     });
                  })(oFloorplan.url);
                  jItem.append(jLink);
                  jList.append(jItem);
               }
               resizeModal();
            }
         });
      }
   }

   /**
    * Open Media Audio/Video content in an IFrame inside a modal window.
    *
    */
   function openVideo( strVideoId, strVideoPath, strStillPath, strDescription, strWidth, strHeight, strType, strEmbedCode ) {
      $.ajax({
         url: "/content/modalVideo.htm",
         success: function(data) {
            m_jModalWindow.html(data);
            $("#modalTitleBar").html(strDescription);

            var frame = $("#c21videoframe");
            var container = $("#modalContainer");

            /*PORTED FROM CLASSIC*/
            var fheight = strHeight;
            var fwidth = strWidth;
            if(strType == null || strType == "" || strType == "flv") {
               fheight = fheight + 14;
            }else{
               fheight = fheight + 9;
               fwidth = fwidth + 17;
            }
            var cwidth = fwidth + 24;
            if (strEmbedCode == null) {
               strEmbedCode = "";
            }


            if( frame ) {
               frame.height(fheight);
               frame.width(fwidth);
               if(strVideoPath != null && strVideoPath != "" && strType == "gen") {
            	  // Video Frame
            	  frame.attr({src: strVideoPath});
               } else if( (strVideoPath == null || strVideoPath == "") && (strType == "gen")) {
            	  // Audio Frame
                  frame.attr({src: "/content/audioFramed?videoid="+strVideoId+"&videopath="+strVideoPath+"&videoimage="+strStillPath+"&height="+strHeight+"&width="+strWidth+"&videotype="+strType+"&embedcode="+CyberUrlEncode(strEmbedCode)});
               } else {
            	  // Video Frame
                  frame.attr({src: "/content/videoFramed?videoid="+strVideoId+"&videopath="+strVideoPath+"&videoimage="+strStillPath+"&height="+strHeight+"&width="+strWidth+"&videotype="+strType+"&embedcode="+CyberUrlEncode(strEmbedCode)});
               }
            }
            if( container ){
               container.width(cwidth);
               container.css('marginLeft', (-1*Math.round(cwidth/2)));
            }
            resizeModal();
         }
      });
   }

   /**
    * Open Media Article content in an IFrame inside a modal window.
    *
    */
   function openMediaArticle( strMediaPath, strStillPath, strCaption, strWidth, strHeight) {
      $.ajax({
         url: "/content/modalMediaArticle.htm",
         success: function(data) {
            m_jModalWindow.html(data);
            $("#modalTitleBar").html(strCaption);

            var frame = $("#c21mediaarticleframe");
            var container = $("#modalContainer");
            var fheight = strHeight + 14;
            var fwidth = strWidth;
            var cwidth = fwidth + 24;

            if( frame ) {
               frame.height(fheight);
               frame.width(fwidth);
               if(strMediaPath != null && strMediaPath != "") {
                  frame.attr({src: strMediaPath});
               }
            }
            if( container ){
               container.width(cwidth);
               container.css('marginLeft', (-1*Math.round(cwidth/2)));
            }
            resizeModal();
         }
      });
   }

   function openDownloads(aDownloads) {
      $.ajax({
         url: "/property/modalList.htm",
         success: function(data) {
            m_jModalWindow.html(data);
            $("#modalTitleBar").html("Choose a Download");
            var jList = $("#modalList");
            for ( var i = 0; i < aDownloads.length; i++) {
               var jItem = $('<li>');
               var jLink = $('<a href="javascript:void(0);"/>');
               var oDownloads = aDownloads[i];
               jLink.text(oDownloads.caption ? oDownloads.caption : oDownloads.url);
               (function(url) {
                  jLink.on("click", function() {
                     modalWindows.openPopupWindow(url, 525, 525);
                  });
               })(oDownloads.url);
               jItem.append(jLink);
               jList.append(jItem);
            }
            resizeModal();
         }
      });
   }

   function openModalWindow(sSubView, sViewEngine, oParams) {
      portalAjax.doViewEngineAjax(sSubView, sViewEngine, oParams ? $.param(oParams) : null);
   }

   function submitModalWindowForm(sSubView, sViewEngine, sParams, options) {
      portalAjax.doViewEngineAjax(sSubView, sViewEngine, sParams, options); // , {loadingIndicator : new LoadingIndicator('#ModalWindow') } -- LOADING INDICATOR THIS BREAKS IE8 COMPAT MODE BAD
   }

   function openEmailAFriend(sPropertyKey) {
      //listHub.doTracking(sPropertyKey, 'PROPERTY_MAP_CLICKED');
      openModalWindow("sendToFriend", "/sendToFriend.c21", { PROPERTYKEY: sPropertyKey });
   }

   function openPropertyMap(sPropertyKey) {
      listHub.doTracking(sPropertyKey, 'PROPERTY_MAP_CLICKED');
      openModalWindow("modalMap", "/propertyMap.c21", { id: sPropertyKey });
      setTimeout(function () {
         $('#modalCloseButton').focus();
         propertyMapModalTabNavigation();
      }, 2000);
   }

   function propertyMapModalTabNavigation() {
      $('#ZoomOutButton').on('keydown', function(e) {
         if(e.key.toLowerCase() === "tab") {
            $('#modalClose').focus()
         }
      })
   }

   function openC21PropertyMap(sPropertyKey, sPropertyGuid) {
      listHub.doTrackingC21(sPropertyGuid, 'PROPERTY_MAP_CLICKED');
      openModalWindow("modalMap", "/propertyMap.c21", { id: sPropertyKey });
   }

   function openConnectionsModal(offerId) {
      openModalWindow("connectionsDetail", "/office.c21", {offer : offerId});
   }

   function openHybridIDX(listingUrl, mlsName) {
      $.ajax({
         url: "/property/hybridModal.htm",
         success: function(data) {
            m_jModalWindow.html(data);
            $("#modalTitleBar").html("");
            $("#modalFrame").attr("src", listingUrl);
            $("#modalNewWindowLink").on("click", function() {
               openPopupWindow(listingUrl, 800, 600);
            });
            resizeModal();
         }
      });
   }

   function resizeModal() {
      if (m_jModalWindow && m_jModalWindow.children().length > 0) {
         var jWindow = $(window),
             jContainer = $("#modalContainer"),
             jBody = $("#modalShadowWrapper"),
             bAutoMaxHeight = jBody.hasClass("autoMaxHeight");
         var iBodyHeight = jContainer.height() - jBody.height() + jBody.contentHeight(),
             iWindowHeight = jWindow.height();
         if (bAutoMaxHeight) {
            jBody.css("height", (iWindowHeight - 96) + "px")
            jContainer.css("top", "5px");
         } else {
            if ((iBodyHeight + 10) > iWindowHeight) {
               jBody.css("max-height", (iWindowHeight - 96) + "px")
               jContainer.css("top", "5px");
            } else {
               jBody.css("max-height", "");
               jContainer.css("top", ((iWindowHeight - iBodyHeight) / 2) + "px");
            }
         }

         jContainer.trigger('modalResize');
      }
   }

   $(window).on('resize', function() {resizeModal()});

   $(document).ready(function() {
      m_jModalWindow = $("#ModalWindow");
      portalAjax.bindLoadEvent(m_jModalWindow, function() {
         cyberFormUtility.emulatePlaceholder();
         ImageLazyLoader.loadImagesIn(m_jModalWindow);
         resizeModal();
      });
   });

   return {
      openModalWindow : openModalWindow,
      submitModalWindowForm : submitModalWindowForm,
      openPopupWindow : openPopupWindow,
      closeWindow : closeWindow,
      openMortgageCalc : openMortgageCalc,
      openContact : openContact,
      openHybridContact : openHybridContact,
      openPropertyContact : openPropertyContact,
      openIDXPropertyContact: openIDXPropertyContact,
      openC21PropertyMap: openC21PropertyMap,
      openVirtualTours : openVirtualTours,
      openVideo : openVideo,
      openMediaArticle: openMediaArticle,
      openDownloads : openDownloads,
      openFloorplans : openFloorplans,
      openPropertyMap : openPropertyMap,
      openEmailAFriend : openEmailAFriend,
      openConnectionsModal : openConnectionsModal,
      openHybridIDX : openHybridIDX,
      resizeModal : resizeModal
   };
}());

/**
 * Manages the current destination list state
 * @param propertyModalMap    the property's instance of PropertyModalMap
 * @param strPropertyAddress  the full address of the property (street, city, state zip)
 * @param aAddresses          the array of addresses to show
 */
window.DestinationManager = function(propertyModalMap, strPropertyAddress, aAddresses) {
   // Array of Destination instances
   var m_aDestinations = [],

      // HashMap of jQuery elements by ID
      m_oDestinationsById = {},

      // The container for the destination elements
      m_jDestinationList;

   /**
    * Update the specified destination with the current miles and minutes
    * @param strId     the id of the destination
    * @param iMiles    the miles to the destination
    * @param iMinutes  the minutes to the destination
    */
   function updateDestination(strId, iMiles, iMinutes) {
      var jDestination = m_oDestinationsById[strId],
         jDistance = jDestination.find('.destinationDistance'),
         jTime = jDestination.find('.destinationTime');

      jDistance.text(iMiles.toString() + ' ' + window.internationalization.getString('mi'));
      jTime.text(iMinutes.toString() + ' ' + window.internationalization.getString('minutes'));
   };

   /**
    * Get the letter of a destination by its position
    * @param iDestinationPosition  the position of the destination
    */
   function getDestinationLetter(iDestinationPosition) {
      // 65 is the character code for "A"
      var iCharCode = 65 + iDestinationPosition,
         strLetter = String.fromCharCode(iCharCode);

      return strLetter;
   }

   /**
    * Add a destination to the list
    * @param destination  an instance of the Destination class
    */
   function addDestination(destination) {
      var strDestinationHtml = [
            '<div class="destination" style="display: none;">',
               '<div class="destinationPin"></div>',
               '<div class="destinationBody">',
                  '<div class="destinationLineOne">',
                     '<span class="destinationName" /> &nbsp;|&nbsp; ',
                     '<span class="destinationDistance">? mi</span> &nbsp;|&nbsp; ',
                     '<span class="destinationTime">? minutes</span>',
                  '</div>',
                  '<div class="destinationLineTwo" />',
               '</div>',
               '<div class="destinationOptions">',
                  '<span class="IconPropertyDrivingDirections16 clickable"></span>',
                  '<span class="IconActionDelete16 clickable"></span>',
               '</div>',
            '</div>'
         ].join(''),
         jDestination = $(strDestinationHtml),
         jPin = jDestination.find('.destinationPin'),
         jLabel = jDestination.find('.destinationName'),
         jLineTwo = jDestination.find('.destinationLineTwo'),
         strLetter = destination.getLetter();

      jPin.addClass('MapPinLegend' + strLetter);
      jLabel.text(destination.getName());
      jLineTwo.text(destination.getAddress());

      m_aDestinations.push(jDestination);
      m_oDestinationsById[destination.getId()] = jDestination;

      // Insert BEFORE the clearing <br> at the end
      m_jDestinationList.children(':last').before(jDestination);
      jDestination.show(400);

      function getDrivingDirections() {
         var strEndAddress = destination.getAddress();
         portalMapping.showDirectionsWindow(strPropertyAddress, strEndAddress);
      }

      jPin.click(getDrivingDirections);

      jDestination.find('.IconActionDelete16').on("click", function() {
         portalAjax.doViewEngineAjax(
            'deleteAddress',
            '/propertyMap.c21',
            $.param({
               'id': destination.getId()
            })
         );
      });

      jDestination.find('.IconPropertyDrivingDirections16').click(getDrivingDirections);
   };

   /**
    * Boot her up
    */
   function initialize() {
      m_jDestinationList = $('#destinationList');
      m_jDestinationList.html('<br style="clear: left" />');

      /**
       * Here's the deal... Bing maps will cancel the last
       * request to get directions if we make another request before
       * the last request is finished. Here I put the information
       * into an array and pop it off as the requests finish.
       */
      var aDestinations = [];

      function findNextDest() {
         var destination = aDestinations.pop();

         // The end of the road (aka array)
         if (!destination) return;

         propertyModalMap.getLocation(destination.getAddress(), function(latLonDest) {
            propertyModalMap.addDestinationPin(destination,
               latLonDest.latitude, latLonDest.longitude);

            destination.setLatitude(latLonDest.latitude);
            destination.setLongitude(latLonDest.longitude);
            propertyModalMap.getDistance(latLonDest, function(iMiles, iMinutes) {
               var strId = destination.getId();
               updateDestination(strId, iMiles, iMinutes);
               findNextDest();
            });
         });
      }

      // Add the destinations to the destination list immediately
      $.each(aAddresses, function(i, json) {
         var strLetter = getDestinationLetter(i),
            destination = new Destination(json, strLetter);
         addDestination(destination);
         aDestinations.push(destination);
      });

      // If the destination list is empty
      if (aDestinations.length == 0) {
         $('#destinationListEmpty').show();
         $('#destinationList').hide();
      } else {
         $('#destinationListEmpty').hide();
         $('#destinationList').show();
      }

      // Start finding the destination info
      findNextDest();
   }

   initialize();
};

/**
 * Represents the data for a single destination
 * @param json  The object to get the destination information from
 */
window.Destination = function(json, strLetter) {
   function safe_tags(str) {
      return str.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&').replace(/&quot;/g,'"').replace(/&#039;/g, "'") ;
   }

   var m_strId = json.id,
      m_strName = safe_tags(json.label),
      m_fLatitude = 0,
      m_fLongitude = 0,
      m_strAddress = json.address;

   // Getters
   this.getId = function() { return m_strId; }
   this.getName = function() { return m_strName; }
   this.getLatitude = function() { return m_fLatitude; }
   this.getLongitude = function() { return m_fLongitude; }
   this.getAddress = function() { return m_strAddress; }
   this.getLetter = function() { return strLetter; }

   // Setters
   this.setName = function(strName) { m_strName = strName; };
   this.setLatitude = function(fLatitude) { m_fLatitude = fLatitude; };
   this.setLongitude = function(fLongitude) { m_fLongitude = fLongitude; };
   this.setAddress = function(strAddress) { m_strAddress = strAddress; };
}

/**
 * Handles the modal property map
 * @param fPropertyLat
 * @param fPropertyLon
 */
window.PropertyModalMap = function(strPropertyAddress, fPropertyLat, fPropertyLon) {
   var m_self = this,
      m_veMap = null,
      m_aPoints = null,
      m_mapPinLayer = null,

      createMap = function() {
         m_veMap = new Microsoft.Maps.Map('#propertyModalMap', {
            credentials: "AqK6Xm4vKQ14R0qING7QBL3FFqQDNoHrM0xVWiVT9yyukhvj7q6TBcylAn6DbA0o",
            center: new Microsoft.Maps.Location(fPropertyLat, fPropertyLon),
         });
      },

      /**
       * Zoom in/out enough to optimally view all the destinations
       */
      autoZoom = function() {
         var locationRect = Microsoft.Maps.LocationRect.fromLocations(m_aPoints);
         m_veMap.setView({
            bounds: locationRect,
         });
      },

      addPushPin = function(sId, fLat, fLon) {
         var location = new Microsoft.Maps.Location(fLat, fLon);
         m_aPoints.push(location);

         var pushPin = new Microsoft.Maps.Pushpin(location, {
            icon: '/fhe/images/office/blue-dot-office-marker.png',
         });

         m_veMap.entities.push(pushPin);

         autoZoom();
      },

      /**
       * Add a destination pin to the map
       * @param destination  the Destination instance
       * @param fLatitude
       * @param fLongitude
       */
      addDestinationPin = function(destination, fLatitude, fLongitude) {
         // Get the directions to the destination
         var location = new Microsoft.Maps.Location(fLatitude, fLongitude),
            strLetter = destination.getLetter();

         // Add the shape to the map
         var pushPin = new Microsoft.Maps.Pushpin(location, {
            text: strLetter,
         });

         m_veMap.entities.push(pushPin);

         // Refresh the zoom
         m_aPoints.push(location);
         autoZoom();

         // Add a click event
         Microsoft.Maps.Events.addHandler(pushPin, 'click', function () {
            portalMapping.showDirectionsWindow(strPropertyAddress, destination.getAddress());
         });
      },

      initialize = function() {
         createMap();

         function onModalResize() {
            var jPropertyModalMapHolder = $('#propertyModalMapHolder'),
               iHeight = 24 + // Extra pixels are from padding
                  $('#modalShadowWrapper').height() -
                  $('#modalDirectionsTop').height() -
                  $('#modalTitle').height(),
               iWidth = jPropertyModalMapHolder.width();

            // Resize the map container
            jPropertyModalMapHolder.height(iHeight);

            // ...
         }

         // When the document is ready
         $(document).ready(function() {
            var jDestinationListContainer = $('#destinationListContainer'),
               jPopoutButton = $('#popoutButton');

            jPopoutButton.on("click", function() {
               jPopoutButton.addClass('popoutButtonGrayed');
               jDestinationListContainer.slideToggle(300, function() {
                  jPopoutButton.removeClass('popoutButtonGrayed');
                  if (jDestinationListContainer.is(':visible')) {
                     jPopoutButton.html(window.internationalization.getString('Hide My List of Destinations'));
                  } else {
                     jPopoutButton.html(window.internationalization.getString('Show My List of Destinations'));
                  }
               });
            });

            // No scrollbars needed
            $('#modalShadowWrapper').css({ overflow: 'hidden' });

            $('#closeModalModal').on("click", function() {
               $('#modalModalContainer').fadeOut();
            });

            onModalResize();
         });

         // When the modal window resizes
         $('#modalContainer').on('modalResize', onModalResize);

         // Start the modal map
         var jSearchNearbyText = $('#searchNearbyText');

         function showNoMatchDialog(strAddress) {
            var jModalModal = $('#modalModalContainer');
            jModalModal.find('.address').text(strAddress);
            $('#panelDestinationName').hide();
            $('#panelDestinationNoMatch').show();
            jModalModal.fadeIn();
         }

         function showQueryNameDialog(strAddress, veLatLong) {
            var jModalModal = $('#modalModalContainer'),
               jDestinationName = $('#destinationName');

            $('#panelDestinationName').show();
            $('#panelDestinationNoMatch').hide();

            function submitNewDestination() {
               var strDestinationName = jDestinationName.val();

               // Clear the value so it won't show up next time
               jDestinationName.val('');

               // TODO: Add destination to server, then call loadDestinations
               portalAjax.doViewEngineAjax(
                  'createAddress',
                  '/propertyMap.c21',
                  $.param({
                     'label': strDestinationName,
                     'address': strAddress
                  })
               );
               jModalModal.fadeOut();
            }

            jDestinationName.unbind('enter').enter(submitNewDestination);
            $('#btnDestinationAdd').unbind('click').click(submitNewDestination);

            jModalModal.fadeIn();
         }

         function doAddressSearch() {
            var strAddress = jSearchNearbyText.val();
            addCommute(strAddress, function(veLatLong) {
               // Found address
               showQueryNameDialog(strAddress, veLatLong);
            }, function() {
               // Failed to find address
               showNoMatchDialog(strAddress);
            });
         }

         $('#btnFindAddress').click(doAddressSearch);
         jSearchNearbyText.enter(doAddressSearch);

         portalAjax.bindLoadEvent($('#addressesJson'), function() {
            // Clear all layers, pins, etc...
            if (!m_mapPinLayer) {
               m_mapPinLayer = new Microsoft.Maps.Layer();
               m_veMap.layers.insert(m_mapPinLayer);
            } else {
               m_mapPinLayer.clear();
            }

            // Reset the state
            m_aPoints = [];

            // Add the property push-pin
            addPushPin("Property", fPropertyLat, fPropertyLon);

            var aAddresses = modalAddresses.addresses,

               // Load (or reload) the destination list from the json
               destinationManager = new DestinationManager(m_self, strPropertyAddress, aAddresses);
         });
      },

      zoomTo = function(fLat, fLon) {
         m_veMap.setView({
            center: new Microsoft.Maps.Location(fLat, fLon),
            zoom: 15
         })
      },

      /**
       * Get a location with the assumption that the address
       * does not need disambiguation. Definitely not for user input
       */
      getLocation = function(strAddress, fnCallback) {
         Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
            var searchManager = new Microsoft.Maps.Search.SearchManager(m_veMap);
            var requestOptions = {
               where: strAddress,
               callback: function (answer, userData) {
                  if (answer.results.length > 0) {
                     fnCallback(answer.results[0].location);
                  } else {
                     throw "Unable to find address " + strAddress;
                  }
               }
            };
            searchManager.geocode(requestOptions);
         });
      },

      urlEncodeLoc = function (loc) {
         return [ loc.latitude, loc.longitude ].join();
      },

      /**
       * Get the distance from the property to the specified coordinates
       * @param latLongTo   the location to get directions to
       * @param fnOnFinish  the function to call after the lookup is finished
       *                    ex: function(iMiles, iMinutes) { ... }
       */
      getDistance = function(latLongTo, fnOnFinish) {
         var latLongFrom = new Microsoft.Maps.Location(fPropertyLat, fPropertyLon);
         $.ajax({
            url: '//dev.virtualearth.net/REST/v1/Routes',
            data: {
               'waypoint.1': urlEncodeLoc(latLongFrom),
               'waypoint.2': urlEncodeLoc(latLongTo),
               distanceUnit: 'mi',
               key: "AqK6Xm4vKQ14R0qING7QBL3FFqQDNoHrM0xVWiVT9yyukhvj7q6TBcylAn6DbA0o",
            },
            dataType: "jsonp",
            jsonp: "jsonp",
            success: function (route, b, c) {
               var leg = route.resourceSets[0].resources[0],
                  iMiles = leg.travelDistance.toFixed(1),
                  iSeconds = leg.travelDuration,
                  iMinutes = (iSeconds - (iSeconds % 60)) / 60;

               fnOnFinish(iMiles, iMinutes);
            },
            error: function (e) {
               alert(e.statusText);
            }
         });
      },

      addCommute = function(strAddress, fnSuccess, fnFailure) {
         Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
            var searchManager = new Microsoft.Maps.Search.SearchManager(m_veMap);
            var requestOptions = {
               where: strAddress,
               callback: function (answer, userData) {
                  if (answer.results.length > 0) {
                     fnSuccess(answer.results[0].location);
                  } else {
                     fnFailure();
                  }
               }
            };
            searchManager.geocode(requestOptions);
         });
      };

   // Public methods
   this.addPushPin = addPushPin;
   this.addDestinationPin = addDestinationPin;
   this.autoZoom = autoZoom;
   this.zoomTo = zoomTo;
   this.getLocation = getLocation;
   this.getDistance = getDistance;

   initialize();
};
